export default __webpack_public_path__ + "static/simple-column-8a4eec406d8fa7858db911dadbc3249c.png";